<div style="padding-top: 4px">
    <p-toast key="message"></p-toast>
    <p-steps
        [model]="items"
        [readonly]="true"
        [activeIndex]="activeIndex"
        (activeIndexChange)="onActiveIndexChange($event)"
        
    ></p-steps>
  </div>
  <br />
  <ng-container *ngIf="activeIndex === 0">
    
  <div>
    <div class="filter-container">
      <!-- Row 2: Select all, dropdowns, and clear all -->
      <div class="filter-row-2 flex align-items-end gap-3">
        <!-- Select All Checkbox -->
        <div class="search-container">
          <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
              type="text"
              pInputText
              placeholder="Search Staff"
              class="search-input"
              (input)="queryData()"
              [(ngModel)]="staffSearchInput"
              appCapitalizeFirstLetter
              appNoLeadingSpace
            />
          </span>
        </div>
      <!-- Select Tag Dropdown -->
          <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2" optionLabel="name"
              [(ngModel)]="selectedRoomId" filterBy="name"  [showClear]="true"
              [options]="roomList" optionValue="id" (onChange)="queryData()"
               [filter]="true" [placeholder]="'Select Classroom'"
              #roomNameDropdown>
          </p-dropdown>
  
        <!-- Select Status Dropdown -->
          <p-dropdown appendTo="body" class="custom-dropdown-filter mr-2 " optionLabel="name"
          [(ngModel)]="selectedDesignation" filterBy="name" [options]="designationList" optionValue="name"
          [filter]="true" placeholder="Select Designation" (onChange)="queryData()"
           #desigNameDropdown>
        </p-dropdown>
  
  
        <!-- Clear All Button -->
        <button pButton type="button" 
         label="Clear All" 
         (click)="onClear()" 
         class="clear-btn"
         ></button>
      </div>
      
      <div class="filter-row-3 flex align-items-end gap-3">
          <div class="flex align-items-end gap-2">
              <p-checkbox
                [binary]="true"
                [(ngModel)]="selectAllStaff"
                (onChange)="toggleAllSelection();checkboxChanged()"
              ></p-checkbox>
              <label for="selectAll" class="mb-0">Select All</label>
            </div>
      </div>
  
    </div>
    
  <p-dataView [value]="staffList" >
      <ng-template let-staff pTemplate="listItem">
        <div class="student-item"
        [ngClass]="{ 'selected-student': staff.selected }">
        <img [src]="staff.profileimg"
            class="border-circle border-2 border-primary inline-block profileImage mr-1"
            alt="Place image title" *ngIf="
            staff.profileimg != null;
            else noImageFound
        " />
        <ng-template #noImageFound>
            <div class="circle flex justify-content-center align-items-center mr-1"
                [style.background-color]="getBackgroundColor(staff.staffId)">
                {{getInitials(staff.staffName)}}
            </div>
        </ng-template>

          <span class="student-name text-primary">{{ staff.staffName }}</span>
          <p-checkbox 
            [(ngModel)]="staff.selected"
            [value]="staff"
            (onChange)="
                toggleSelection(staff);
                isSelected(staff);
                checkboxChanged();"
          [binary]="true"></p-checkbox>
        </div>
      </ng-template>
      <ng-template pTemplate="empty">
        <div class="row" style="justify-content: center;">
          <span class="text-primary text-center">
            No result found
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
          <div class="flex align-items-center justify-content-center gap-3">
            <button pButton pRipple 
              type="button" label="Cancel"
              class="p-button-outlined"
              (click)="ref.close()"
            ></button>
            <button pButton pRipple 
              label="Continue" id="save"
              (click)="complete()"
              ></button>
          </div>
      </ng-template>
  </p-dataView>
  
  
  </div>
  </ng-container>
  
  <ng-container *ngIf="activeIndex === 1">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="selected-students-container">
          <div class="student-card " *ngFor="let staff of selectedStaff">
            <img
              *ngIf="staff.profileimg; else noImageFound"
              [src]="staff.profileimg"
              alt="Student Photo"
              class="student-photo"
            />
            <ng-template #noImageFound>
              <img
                src="assets/layout/images/male.png"
                alt="Fallback Image"
                class="student-photo"
              />
            </ng-template>
  
            <!-- Student Name -->
            <span class="student-name align-items-left">{{ staff.staffName }}</span>
  
            <!-- Delete Icon -->
            <button
              class="delete-btn"
              (click)="onRemoveStaff($event,staff)"
            >
            <i class="pi pi-trash"></i>
            <p-confirmPopup key="confirm2"></p-confirmPopup>
  
            </button>
          </div>
        </div>
      </div>
    </div>

    <form [formGroup]="staffSignIn">
    <div class="col-12 col-md-12 row">
            <!-- <div class="col-4">
                <label class="text-sm font-normal mb-1" style="opacity: 50%;">Date</label>
                <input id="email2" class="form-control search-input custom-input-filter w-full" placeholder="Date" id="date"
                    formControlName="date" [attr.max]="today"  type="date"/>
            </div> -->
            <div class="col-4">
                <label class="text-sm font-normal mb-1" style="opacity: 50%;">Time</label>
                <input pInputText type="time" class="form-control search-input custom-input-filter w-full" id="time"
                formControlName="signOutTime" />
            </div>
        </div>
    </form>

  </div>
    <div class="flex align-items-center justify-content-center gap-3">
        <button pButton pRipple 
          type="button" label="Back"
          class="p-button-outlined"
          (click)="prevPage()"
          [disabled]="fromOverView"
        ></button>
        <button pButton pRipple 
          label="Save" id="save"
          [disabled]="selectedStaff.length == 0"
          (click)="onSave()"
          ></button>
    </div>
  
  </ng-container>
  